<div fxLayout="row" class="background">
    <div fxFlex="80" fxFlexOffset="10%">

        <section id="header">
            <h1 class="h1Header">CONSULTA DE LIQUIDACIONES</h1>
        </section>

        <section id="body">
            <mat-card class="mat-elevation-z0">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <button mat-flat-button (click)="clientView()" class="squared-btn" *ngIf="isRedelivery">Liquidación clientes</button>
                    <button mat-flat-button (click)="clientServicesView()" class="squared-btn" *ngIf="isCoopExpress">Liquidación clientes de servicios</button>
                    <button mat-flat-button (click)="cadeteView()" class="squared-btn" *ngIf="isRedelivery">Liquidación cadetes</button>
                    <button mat-flat-button (click)="particularView()" class="squared-btn" *ngIf="isCoopExpress">Liquidación mensajería</button>
                </div>
                <mat-divider></mat-divider>
                <h2 class="cardHeader">{{title}}</h2>
                <form [formGroup]="liquidacionesForm" (ngSubmit)="search(liquidacionesForm.value)">
                    <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="1rem" id="filters">
                        <div fxFlex="30" *ngIf="isClient">
                            <mat-form-field appearance="outline">
                                <mat-label>Empresa</mat-label>
                                <mat-select formControlName="client">
                                    <mat-option *ngFor="let store of allStores" [value]="store.cdStore">
                                        {{store.dsName}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div fxFlex="30" *ngIf="isClientServices">
                            <mat-form-field appearance="outline">
                                <mat-label>Cliente</mat-label>
                                <mat-select formControlName="client" (selectionChange)="onClientSelectionChange()">
                                    <mat-option *ngFor="let client of allServiceClients" [value]="client.cdClient">
                                        {{client.dsNombreFantasia || client.dsRazonSocial}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div fxFlex="30" *ngIf="!isClient && !isClientServices">
                            <mat-form-field appearance="outline">
                                <mat-label>Cadetes</mat-label>
                                <mat-select formControlName="delivery">
                                    <mat-option *ngFor="let delivery of allDeliveries" [value]="delivery.cdDelivery">
                                        {{delivery.dsName}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div fxFlex="30">
                            <mat-form-field appearance="outline">
                                <mat-label>Desde</mat-label>
                                <input matInput (dateInput)="inpuDateFrom($event)" [matDatepicker]="dateFrom" readonly>
                                <mat-datepicker-toggle matSuffix [for]="dateFrom"></mat-datepicker-toggle>
                                <mat-datepicker #dateFrom>
                                </mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div fxFlex="30">
                            <mat-form-field appearance="outline">
                                <mat-label>Hasta</mat-label>
                                <input matInput [matDatepicker]="dateTo" (dateInput)="inpuDateTo($event)" readonly>
                                <mat-datepicker-toggle matSuffix [for]="dateTo"></mat-datepicker-toggle>
                                <mat-datepicker #dateTo>
                                </mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div fxFlex="10">
                            <button mat-flat-button class="squared-btn" type="submit">Buscar</button>
                        </div>
                    </div>
                </form>

                <table mat-table [dataSource]="dataSource" class="mat-elevation-z0" id="table"
                       [class.client-services-table]="isClientServices">

                    <ng-container matColumnDef="id" *ngIf="isClient">
                        <th mat-header-cell *matHeaderCellDef class="table-header">ID</th>
                        <td mat-cell *matCellDef="let element"> {{element.cdStorePaying}} </td>
                    </ng-container>

                    <ng-container matColumnDef="id" *ngIf="!isClient && !isClientServices">
                        <th mat-header-cell *matHeaderCellDef class="table-header">ID</th>
                        <td mat-cell *matCellDef="let element"> {{element.cdDriverPaying}} </td>
                    </ng-container>

                    <ng-container matColumnDef="id" *ngIf="isClientServices">
                        <th mat-header-cell *matHeaderCellDef class="table-header">ID</th>
                        <td mat-cell *matCellDef="let element"> {{element.cdClientPaying}} </td>
                    </ng-container>

                    <ng-container matColumnDef="numero" *ngIf="isClientServices">
                        <th mat-header-cell *matHeaderCellDef class="table-header">N° LIQUIDACIÓN</th>
                        <td mat-cell *matCellDef="let element"> {{element.dsNumeroLiquidacion || '-'}} </td>
                    </ng-container>

                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef class="table-header">FECHA</th>
                        <td mat-cell *matCellDef="let element"> {{element.dtFecha | date: 'short'}} </td>
                    </ng-container>

                    <ng-container matColumnDef="total">
                        <th mat-header-cell *matHeaderCellDef class="table-header">TOTAL</th>
                        <td mat-cell *matCellDef="let element"> {{element.qtTotal}} </td>
                    </ng-container>

                    <ng-container matColumnDef="net">
                        <th mat-header-cell *matHeaderCellDef class="table-header">NETO</th>
                        <td mat-cell *matCellDef="let element"> {{element.qtNeto}} </td>
                    </ng-container>

                    <ng-container matColumnDef="commission">
                        <th mat-header-cell *matHeaderCellDef class="table-header">COMISIÓN</th>
                        <td mat-cell *matCellDef="let element"> {{element.qtComision}} </td>
                    </ng-container>

                    <ng-container matColumnDef="liquidacion">
                        <th mat-header-cell *matHeaderCellDef class="table-header">LIQUIDACIÓN</th>
                        <td mat-cell *matCellDef="let element"> {{element.qtPaying}} </td>
                    </ng-container>

                    <ng-container matColumnDef="pdf">
                        <th mat-header-cell *matHeaderCellDef class="table-header">PDF</th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-flat-button class="squared-btn" (click)="exportPDF(element)">Generar</button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                <mat-paginator *ngIf="isClientServices"
                               [length]="clientLiqTotalCount"
                               [pageSize]="clientLiqPageSize"
                               [pageIndex]="clientLiqPageIndex"
                               [pageSizeOptions]="[10, 20, 50, 100]"
                               (page)="onClientLiqPage($event)"
                               showFirstLastButtons>
                </mat-paginator>
                <div *ngIf="dataSource.length == 0 && searched" fxLayout="row" fxLayoutAlign="center center">
                    <span class="cardHeader">
                        No se encontraron liquidaciones</span>
                </div>
            </mat-card>
        </section>
    </div>
</div>